export const CONTACT = {
  name: "Comfort Line Bútoráruház Keszthely",
  shortName: "Comfort Line Bútoráruház",
  city: "Keszthely",
  address: "8360 Keszthely, Martinovics utca 88/c.",
  addressNote: "A STOP SHOP-pal szemben, bejárat a Martinovics utca felől",
  phone: "+36 20 295 4161",
  phoneHref: "tel:+36202954161",
  centralPhone: "+36 83 310 242",
  centralPhoneHref: "tel:+3683310242",
  email: "keszthely@comfortbutor.hu",
  tagline: "Kiemelkedő bútorválaszték a Balaton nyugati részén",
};

export const HOURS = [
  { days: "Hétfő – Péntek", time: "9:00 – 18:00" },
  { days: "Szombat", time: "9:00 – 14:00" },
  { days: "Vasárnap", time: "Zárva" },
];

export const PICKUP_NOTE =
  "Árukiadás hétköznap 9:00 – 17:00 között. Fizetés bankkártyával, banki átutalással vagy készpénzzel – ingyenes parkolás az áruház előtt.";

export const LANGUAGES = [
  { flag: "/assets/flag-de.png", label: "Wir sprechen Deutsch", alt: "Német zászló" },
  { flag: "/assets/flag-en.png", label: "We speak English", alt: "Angol zászló" },
  { flag: "/assets/flag-ru.png", label: "Мы говорим по-русски", alt: "Orosz zászló" },
];

export const LINKS = {
  mainSite: "https://comfortbutor.hu/",
  akciok: "https://comfortbutor.hu/keszthelyi-butor-akciok-kiarusitas/",
  galeria: "https://comfortbutor.hu/keszthely-butorbolt/#kepgaleria-keszthely",
  vasarloiFotok: "https://comfortbutor.hu/vasarloi-fotok/",
  keszthelyPage: "https://comfortbutor.hu/keszthely-butorbolt/",
  andanteMarkabolt: "https://comfortbutor.hu/andante-markabolt/",
  brwMarkabolt: "https://comfortbutor.hu/black-red-white-markabolt/",
  youtube: "https://www.youtube.com/@comfortlinebutoraruhazak",
  facebook: "https://www.facebook.com/comfortbutoraruhaz/",
  instagram: "https://www.instagram.com/comfortbutor",
  mapsDirections:
    "https://www.google.com/maps/dir//Comfort%20Line%20B%C3%BAtor%C3%A1ruh%C3%A1z%20Keszthely",
  mapsEmbed:
    "https://www.google.com/maps?q=Comfort%20Line%20B%C3%BAtor%C3%A1ruh%C3%A1z%20Keszthely%2C%20Martinovics%20utca%2088%2Fc&output=embed",
  stores: [
    { name: "Keszthely", url: "https://comfortbutor.hu/keszthely-butorbolt/" },
    { name: "Nagykanizsa", url: "https://comfortbutor.hu/nagykanizsa-butorbolt/" },
    { name: "Veszprém", url: "https://comfortbutor.hu/veszprem-butorbolt/" },
  ],
};

export const IMPRESSUM = {
  company: "Comfort Line Kft.",
  seat: "8360 Keszthely, Martinovics utca 88/c.",
  tax: "11525150-2-20",
  representative: "Balogh Benjámin Attila, ügyvezető",
  phone: "+36 83 310 242",
  email: "info@comfortbutor.hu",
  hosting: "Emergent Labs Inc. – emergent.sh",
};

export const IMAGES = {
  logo: "/assets/logo.png",
  hero: "/assets/hero-oslo.webp",
  heroAlt: "Andante OSLO prémium valódi bőr ülőgarnitúra – Comfort Line Bútoráruház Keszthely",
  exterior: "/assets/exterior.webp",
  truck: "/assets/truck.jpg",
};

export const NAV_LINKS = [
  { label: "Márkáink", href: "#markak" },
  { label: "Választék", href: "#valasztek" },
  { label: "Szolgáltatások", href: "#szolgaltatasok" },
  { label: "Bemutatóterem", href: "#bemutatoterem" },
  { label: "Kapcsolat", href: "#kapcsolat" },
];

export const HERO = {
  eyebrow: "Comfort Line Bútoráruház · 2007 óta – már 20 éve",
  lines: [
    { text: "Igényes, stílusos", accent: false },
    { text: "bútorok Keszthelyen\u00A0–", accent: true },
    { text: "akár készletről,", accent: false },
    { text: "azonnal.", accent: false },
  ],
  lead: "Próbálja ki személyesen 1500 m²-es, kétszintes áruházunkban a Martinovics utcában – a STOP SHOP-pal szemben. A Comfort Line Bútoráruházak első üzleteként 2007 óta várjuk: magyar és európai bútorok nagy választékban, kedvező ár-érték aránnyal – a megfizethető alapdaraboktól a prémium kollekciókig.",
  badgeEyebrow: "Andante márkabolt · BRW hivatalos forgalmazó",
  badgeLine: "Andante · Black Red White · Kanizsa Trend",
};

export const HERO_PILLS = [
  "Andante márkabolt",
  "2 szint, 1500 m²",
  "Sok termék készletről",
  "Ingyenes parkolás",
  "100% hazai tulajdon",
];

export const MARQUEE_ITEMS = [
  "Comfort Line Bútoráruház",
  "Andante",
  "Black Red White",
  "Kanizsa Trend",
  "Akár készletről azonnal",
  "Egyedi konfigurációk",
  "Magyar bútorok",
  "100% hazai tulajdon",
  "2 szinten, 1500 m²",
  "Ingyenes parkolás",
];

export const CATEGORIES_INTRO = {
  eyebrow: "Választékunk",
  title: "Bútorok minden helyiségbe – sok termék azonnal elvihető",
  linkLabel: "Teljes kínálat a comfortbutor.hu-n",
};

export const CATEGORIES = [
  {
    title: "Kanapék & sarokülők",
    desc: "Ülőgarnitúrák, ágyazható kanapék és fotelek hatalmas választékban",
    img: "/assets/cat/sarokgarnitura-terra.webp",
    alt: "Andante Terra Tango U-alakú sarokgarnitúra türkizkék Touch me szövettel – Comfort Line Keszthely",
    href: "https://comfortbutor.hu/ulogarniturak-sarokulok-sarokkanape/",
    badge: "Legnépszerűbb",
  },
  {
    title: "Ágyak & matracok",
    desc: "Ágykeretek, matracok és ágybetétek az egészséges alvásért",
    img: "/assets/cat/franciaagy.webp",
    alt: "Prémium franciaágy a Comfort Line kínálatából",
    href: "https://comfortbutor.hu/agyak-agykeretek/",
    badge: "Egészséges alvás",
  },
  {
    title: "Étkezőasztalok & székek",
    desc: "Étkezőszettek a családi otthonokba",
    img: "/assets/cat/etkezo.webp",
    alt: "Bővíthető étkezőasztal a Comfort Line kínálatából",
    href: "https://comfortbutor.hu/etkezok-asztalok-szekek/",
    badge: "Családi otthon",
  },
  {
    title: "Gardróbszekrények",
    desc: "Tolóajtós gardróbok, ruhásszekrények – egyedi tervezéssel",
    img: "/assets/cat/gardrob.webp",
    alt: "Tolóajtós gardróbszekrény a Comfort Line kínálatából",
    href: "https://comfortbutor.hu/gardrobok-haloszoba-szekrenyek/",
    badge: "Egyedi tervezés",
  },
  {
    title: "Fenyőbútorok",
    desc: "Natúr lakkozott és pácolt tömör fenyőfa bútorok",
    img: "/assets/cat/fenyo.webp",
    alt: "Tömör fenyőfa enteriőr a Comfort Line kínálatából",
    href: "https://comfortbutor.hu/fenyobutorok-tomorfa/",
    badge: "Tömör fa",
  },
  {
    title: "Szekrények & komódok",
    desc: "Elemes nappali és hálószoba bútorok, kiegészítők",
    img: "/assets/cat/szekrenyek.webp",
    alt: "Elemes komód a Comfort Line kínálatából",
    href: "https://comfortbutor.hu/elemes-nappali-butorok-szekrenysorok/",
    badge: "Azonnal elvihető",
  },
];

export const CONFIG_NOTE = {
  bold: "Sok modellünk egyedi konfigurációban is megrendelhető",
  text: "– választható szín, szövet, méret és funkció. Ezeket egyéni igény szerint rendeljük, ezért nem tartunk belőlük minden változatot készleten – bemutatótermünkben szívesen segítünk a konfigurálásban.",
};

export const BRANDS_INTRO = {
  eyebrow: "Márkáink",
  title: "Andante márkabolt és BRW hivatalos forgalmazó Keszthelyen",
  text: "Áruházunkban élőben is kipróbálhatja az ismert magyar és európai gyártók kollekcióit – a teljes kínálatot, katalógusokat és referenciákat főoldalunkon, a comfortbutor.hu-n is böngészheti.",
};

export const BRANDS = [
  {
    name: "Andante",
    logo: "/assets/brand/andante.jpg",
    alt: "Andante logó",
    badge: "Márkabolt",
    desc: "Prémium kárpitozott ülőgarnitúrák és kanapék magyar gyártásból",
  },
  {
    name: "Black Red White",
    logo: "/assets/brand/brw.png",
    alt: "Black Red White logó",
    badge: "Hivatalos forgalmazó",
    desc: "Stílusos elemes nappali, hálószoba és előszoba bútorok (BRW)",
  },
  {
    name: "Kanizsa Trend",
    logo: "/assets/brand/kanizsa-trend.jpg",
    alt: "Kanizsa Trend logó",
    badge: "Márkabolt",
    desc: "Stílusos magyar kanapék, fotelek és sarokülők nagy választékban",
  },
];

export const BRANDS_HIGHLIGHT = {
  bold: "A legnagyobb nagykanizsai bútorgyártó balatoni márkaboltja vagyunk – szoros együttműködésben a gyártóval.",
  text: "Keszthelyen az Andante és a Kanizsa Trend gyártó nem rendelkezik saját márkaboltal és ügyfélfogadással – ezt a szerepet mi töltjük be, így a Balaton nyugati részén kiemelkedő Andante és Kanizsa Trend modellválaszték található nálunk.",
};

export const BRANDS_NOTE =
  "Kiemelt márkáinkon kívül nagyon sok más hazai és európai bútorgyártó – Etsberger, Best Dream, Délity, SleepSentry és mások –, asztalosműhely termékei is megtalálhatók áruházunkban – kérje munkatársaink segítségét, ha konkrét gyártót vagy terméket keres.";

export const TIPS_INTRO = {
  eyebrow: "Szakértői tanácsok",
  title: "Így érdemes bútort választani",
  text: "Bútorvásárlás előtt érdemes néhány szempontot átgondolni – az alábbi, általános érvényű tippekkel segítünk, hogy hosszú távon is jó döntést hozzon, akár nálunk, akár máshol vásárol.",
};

export const TIPS = [
  {
    icon: "ruler",
    title: "Mérjen fel pontosan otthon",
    text: "Mérje fel a helyiség alapméreteit, az ajtónyílásokat, a lépcsőfordulókat és a radiátorok, konnektorok helyét is. Egy jól kinéző bútor akkor igazán jó választás, ha a méretei is passzolnak – ha bizonytalan, bemutatótermi tanácsadás során segíteni tudnak a megfelelő méret és elrendezés kiválasztásában.",
  },
  {
    icon: "sofa",
    title: "Próbálja ki személyesen",
    text: "Az ülés- és fekvéskényelmet, a kárpit tapintását és a színek valós árnyalatát fotók alapján szinte lehetetlen megítélni. Érdemes olyan áruházat választani, ahol a modellek ki vannak állítva, és szabadon kipróbálhatók – tíz perc próba sokkal többet árul el, mint tíz termékfotó.",
  },
  {
    icon: "bed",
    title: "Matracnál az alvási szokásai a mérvadók",
    text: "Oldalt alvóknak általában a puhább, nyomáselosztó felület (például hideghab vagy kényelmi réteges matrac), háton alvóknak a stabilabb tartás szokott beválni; táskarugós matracnál a pontalátámasztás, hideghabnál a rétegsűrűség érdemel figyelmet. A döntéshez a legtöbbet egy olyan részleg segít, ahol több típust egymás mellett ki is próbálhat.",
  },
  {
    icon: "layers",
    title: "Válasszon tudatosan anyagot és kárpitot",
    text: "A valódi bőr időtálló és patinásodik, a szöveteknél a kopásállósági (Martindale) érték és a folttaszító kezelés számít. Gyerekes vagy háziállatos háztartásba érdemes mosható, strapabíró huzatot keresni – sok gyártónál a kárpit és szín egyedileg is variálható, így nem kell kompromisszumot kötni.",
  },
  {
    icon: "truck",
    title: "Kérdezzen rá a szállításra és összeszerelésre",
    text: "Vásárlás előtt tisztázza, hogy a bútor lapraszerelt vagy egyben érkezik-e, belefér-e a szállítás a lakásáig, és ki végzi az összeszerelést. A saját járműparkkal dolgozó áruházaknál a kiszállítás általában kiszámíthatóbb, a szakszerű összeszerelés pedig megvédi a bútort és a garanciális jogait is.",
  },
  {
    icon: "zap",
    title: "Készlet vagy rendelés – tervezzen időben",
    text: "Ha sürgős a beköltözés vagy az ajándék, kérdezze meg, mi érhető el azonnal készletről: sok kiállított modell azonnal elvihető vagy napokon belül kiszállítható. Egyedi konfigurációnál számoljon gyártási határidővel – jó kompromisszum lehet egy készletes darab azonnal, és egy álmaihoz konfigurált modell későbbre.",
  },
];

export const MATTRESS_STUDIO = {
  eyebrow: "Alvásstúdió",
  title: "Külön ágy- és matracrészleg várja vásárlóinkat",
  text: "Áruházunkban külön, alvásstúdió-jellegű ágy- és matracrészleg működik, ahol kiállított, kipróbálható matracokkal segítünk megtalálni az Ön számára ideális fekvőfelületet. Kínálatunkban rugómentes hideghab matracok, táskarugós matracok, valamint kényelmi réteggel – memóriahabbal, latexszel, coolgel memory habbal vagy komforthabbal – készült modellek egyaránt megtalálhatók, a középkategóriától a prémium kategóriáig. Forgalmazott márkáink közé tartozik a Best Dream, a SleepSentry és a Moonlight, emellett számos más minőségi, tartós és kényelmes matrac közül is válogathat.",
  image: "/assets/gal-n1.webp",
  imageAlt: "A keszthelyi áruház alvásstúdiója – kipróbálható matracok és ágyak a matracrészlegen",
  imageBadge: "Kipróbálható a bemutatótérben",
  types: ["Hideghab", "Táskarugós", "Memóriahab", "Latex", "Coolgel memory", "Komforthab"],
  brands: [
    { name: "Best Dream", logo: "/assets/brand-bestdream.png" },
    { name: "SleepSentry", logo: "/assets/brand-sleepsentry.png" },
    { name: "Moonlight", logo: null },
  ],
  linkLabel: "Matracválaszték a comfortbutor.hu-n",
  linkHref: "https://comfortbutor.hu/matracok-agybetetek/",
};

export const WHY_VISIT_INTRO = {
  eyebrow: "Miért jöjjön el személyesen?",
  title: "Bútort és matracot személyesen érdemes választani",
  text: "Keszthelyen nyílt meg 2007-ben a 100%-ban hazai tulajdonú Comfort Line Bútoráruházak első üzlete – azóta is itt van a cég székhelye. Tágas, 2 szintes, 1500 m²-es bemutatótérrel várjuk vásárlóinkat: igényes, stílusos bútorok nagy választékban, akár raktárkészletről azonnal, megfizethető áron – a kedvező árú alap- és középkategóriától a prémium darabokig.",
};

export const WHY_VISIT = [
  {
    icon: "eye",
    title: "Élőben láthatja",
    text: "A képek sokszor nem adják vissza a bútorok minőségét, színét és anyagát – nálunk mindent megnézhet közelről.",
  },
  {
    icon: "sofa",
    title: "Ki is próbálhatja",
    text: "Üljön bele a kanapéba, feküdjön rá a matracra: a kényelmet és a tapintást csak személyesen lehet megítélni.",
  },
  {
    icon: "handheart",
    title: "Szakértő segítség",
    text: "Hozzáértő munkatársaink segítenek kiválasztani a színeket, szöveteket és az ideális bútort az otthonába.",
  },
];

export const GALLERY = [
  { src: "/assets/gal-n5.webp", alt: "U-alakú bőr sarokgarnitúra a keszthelyi áruház bemutatótermében" },
  { src: "/assets/gal-n4.webp", alt: "Andante szövetkanapé a keszthelyi bemutatóteremben" },
  { src: "/assets/gal-n2.webp", alt: "Étkezőasztalok és székek a keszthelyi bemutatóteremben" },
  { src: "/assets/gal-n3.webp", alt: "Franciaágyak az emeleti bemutatótérben" },
  { src: "/assets/gal-n1.webp", alt: "Matracok és ágyak a keszthelyi áruházban" },
];

export const STATS = [
  { value: "1500 m²", label: "2 szinten – a Balaton nyugati részén kiemelkedő választék" },
  { value: "2007", label: "itt nyílt az első Comfort Line áruház" },
  { value: "3", label: "áruház országszerte" },
  { value: "100%", label: "hazai tulajdon" },
];

export const REVIEWS_ENABLED = true;

export const REVIEWS_INTRO = {
  eyebrow: "Vásárlói vélemények",
  title: "Ezt mondják rólunk vásárlóink",
};

export const REVIEWS_SUMMARY = {
  rating: "4,8",
  count: "1100+ hiteles értékelés",
  sub: "a Comfort Line áruházakra",
  badge: "Trustindex „Kiváló“ minősítés",
};

export const REVIEWS = [
  {
    name: "Lili Novak",
    platform: "Google",
    date: "2026. január",
    rating: 5,
    text: "Nagyon elégedett vagyok a Comfort Line Áruházzal! Külön köszönet a Keszthelyi Áruházban Legény Nikolettnek! A konyhabútorom a megbeszéltek szerint készült el, még az utólagos igényeimet is rugalmasan és kedvesen megoldották. Mindenkinek csak ajánlani tudom!",
  },
  {
    name: "Sevcsik Boglárka",
    platform: "Google",
    date: "2026. január",
    rating: 5,
    text: "Több alkalommal vásároltunk bútorokat a keszthelyi áruházban. Nagyon köszönjük a segítséget a bútorok kiválasztásánál. A kiszállítást és összeszerelést végző kollégák munkájával is tökéletesen elégedettek voltunk. Visszatérő vásárlók leszünk!",
  },
  {
    name: "Kebelei Ildikó",
    platform: "Facebook",
    date: "2026. július",
    rating: 5,
    text: "A Keszthelyi üzletben: nagyon segítőkész az eladó úr, udvarias, figyelmes! A szállítás pontos, a szerelők kedvesek, figyelmesek! Aki tényleg vásárolni szeretne, bátran kérjen segítséget tőlük – mindenben segítenek!",
  },
  {
    name: "Gáspárné Farkas Bella",
    platform: "Facebook",
    date: "2021. december",
    rating: 5,
    text: "Imádjuk! Strapabíró, modern bútorok! Keszthelyi bolt eladói pedig profik, kedvesek, segítőkészek! Köszönjük.",
  },
];

export const SERVICES_INTRO = {
  eyebrow: "Szolgáltatásaink",
  title: "Több mint bútorbolt – teljes körű kiszolgálás",
};

export const SERVICES = [
  {
    icon: "truck",
    title: "Házhozszállítás",
    text: "Bútor házhozszállítás Keszthelyen és környékén, a teljes Dunántúlon és Budapest területén.",
  },
  {
    icon: "wrench",
    title: "Összeszerelés",
    text: "Lapra szerelt bútorok szakszerű összeszerelése – igény esetén az Ön otthonában.",
  },
  {
    icon: "compass",
    title: "Szaktanácsadás",
    text: "Segítünk kiválasztani a tökéletes szövetet, méretet és funkciót az otthonához.",
  },
  {
    icon: "scissors",
    title: "Egyedi tervezés",
    text: "Konyhabútorok, tolóajtós gardróbszekrények, elemes ülő- és sarokgarnitúrák tervezése egyedi igények szerint.",
  },
  {
    icon: "parking",
    title: "Ingyenes parkolás",
    text: "Kényelmes, ingyenes parkolás ügyfeleink részére közvetlenül az áruház előtt.",
  },
  {
    icon: "card",
    title: "Rugalmas fizetés",
    text: "Fizetés bankkártyával, készpénzzel vagy banki átutalással – ahogy Önnek kényelmes.",
  },
];

export const VIDEO = {
  eyebrow: "Videós bemutatkozás",
  title: "Nézzen körül keszthelyi áruházunkban",
  caption: "Bemutatóvideónk hamarosan – addig is: Comfort Line a YouTube-on",
  linkLabel: "Comfort Line Bútoráruházak a YouTube-on",
};

export const CONTACT_INTRO = {
  eyebrow: "Kapcsolat & megközelítés",
  title: "Várjuk Keszthelyen, a Martinovics utcában",
};

export const CTA_CARDS = [
  { icon: "tag", title: "Aktuális akcióink", href: LINKS.akciok, testid: "cta-akciok" },
  { icon: "camera", title: "Vásárlóinknál készült fotók", href: LINKS.vasarloiFotok, testid: "cta-vasarloi-fotok" },
  { icon: "images", title: "Képgaléria az áruházról", href: LINKS.galeria, testid: "cta-galeria" },
];

export const FAQ_INTRO = {
  eyebrow: "Gyakori kérdések",
  title: "Gyakran ismételt kérdések",
};

export const FAQ = [
  {
    q: "Hol található a keszthelyi áruház?",
    a: "Áruházunk címe: 8360 Keszthely, Martinovics utca 88/c. – a STOP SHOP-pal szemben, bejárat a Martinovics utca felől. Ingyenes parkolás vásárlóink részére.",
  },
  {
    q: "Mikor van nyitva az áruház?",
    a: "Hétfőtől péntekig 9–18 óráig, szombaton 9–14 óráig várunk, vasárnap zárva tartunk. Árukiadás hétköznap 9–17 óráig.",
  },
  {
    q: "Elvihető azonnal a kiválasztott bútor?",
    a: "Sok kiállított termékünk készletről azonnal elvihető vagy rövid határidővel kiszállítható. A bemutatott bútorok a készlet erejéig érhetők el, kínálatunk folyamatosan változik.",
  },
  {
    q: "Vállalnak házhozszállítást és összeszerelést?",
    a: "Igen, saját járműparkkal szállítunk a Dunántúl teljes területén és Budapesten is. Lapraszerelt termékeinkhez igény szerint szakszerű összeszerelést biztosítunk.",
  },
  {
    q: "Milyen fizetési módok érhetők el?",
    a: "Áruházunkban bankkártyás, banki átutalásos és készpénzes fizetésre is van lehetőség.",
  },
  {
    q: "Beszélnek idegen nyelveken az áruházban?",
    a: "Igen, vásárlóinkat németül (Wir sprechen Deutsch), angolul (We speak English) és oroszul (Мы говорим по-русски) is kiszolgáljuk.",
  },
];

export const SERVICE_AREA_INTRO = {
  title: "Kiemelt szolgáltatási területünk",
  text: "Házhozszállítás és bútor-összeszerelés az alábbi településeken és vonzáskörzetükben – ezen felül a Dunántúl egész területén és Budapesten is szállítunk.",
};

export const SERVICE_AREAS = [
  "Keszthely",
  "Hévíz",
  "Tapolca",
  "Sümeg",
  "Zalaegerszeg",
  "Marcali",
  "Fonyód",
  "Badacsony",
  "Keszthely környéke",
];

export const FOOTER_DOMAIN_NOTE =
  "A butor-keszthely.hu domain a Comfort Line Bútoráruház hivatalos keszthelyi oldala.";
